// Returns the browser's preferred languages in order, e.g. ["fr", "en", "de"]
export default function getBrowserLocales(options = {}) {
  const defaultOptions = { countryCodeOnly: false }

  const opt = { ...defaultOptions, ...options }

  const navigatorLocales =
    navigator.languages !== undefined
      ? navigator.languages
      : [navigator.language]

  return navigatorLocales
    .filter(Boolean)
    .map(locale => opt.countryCodeOnly
      ? locale.trim().split(/-|_/)[0].toLowerCase()
      : locale.trim())
}
